import store from '@/store'
import config from '@/config'
import lib from '@/library'
import router from '@/router'
// import Axios from 'axios'
import BettingOffer from '@/components/mixins/BettingOffer'

export default {
  isSGP,
  betType,
  getOrigin,
  fetchPopularParlays,
  parlayPotentialReturn
}

function fetchPopularParlays (userId, eventId, competitionId, sportTypeId) {
  const isPopularParlaysTabActive = store.getters['featureTabsState/getActiveTab'] === 'popularParlays'
  let uid = (userId === 'undefined' ? null : userId)
  let location = router.currentRoute.name !== 'event' ? 'widget:popularparlays' : null
  const isParlayZone = router.currentRoute.name === 'parlayzone'

  const payload = {
    uid,
    eventId,
    location,
    sportTypeId,
    allin: !config.app.autoconf.PLAYER_PERSONALISATION.multiSportParlaysAvailableOnSportPage
  }

  const competitionIdQuery =
    Array.isArray(competitionId) && competitionId.length
      ? competitionId
        .filter(Boolean)
        .map(id => `competitionId=${encodeURIComponent(String(id))}`)
        .join('&')
      : ''

  const endpoint = competitionIdQuery
    ? `getpopularparlays?${competitionIdQuery}`
    : 'getpopularparlays'

  if (!config.app.autoconf.PLAYER_PERSONALISATION.enablePopularParlays) {
    store.commit('featureTabsState/setIsLoading', false)
    return
  }
  if (config.app.autoconf.PLAYER_PERSONALISATION.enablePopularParlays) {
    if (config.app.autoconf.FEATURES_TABS.popularParlays.enabled && isPopularParlaysTabActive) {
      store.commit('featureTabsState/setIsLoading', true)
    }
    lib.rpcService.callBroker('personalization', endpoint, payload)
      .then(response => {
        let popularParlays = []
        let allPopularParlays = (response && response.result) || []
        if (allPopularParlays.length === 0) {
          store.commit('popularParlaysState/setPopularParlays', [])
          return false
        }
        if (router.currentRoute.query.debug) {
          debugLog(['All Popular Parlays:', allPopularParlays])
          let parlayNames = allPopularParlays.map(pp => pp.Name)
          debugLog(['parlayNames:', parlayNames])
          let IDFWMarketGroups = allPopularParlays.map(pp => pp.IDFWMarketGroup)
          debugLog(['IDFWMarketGroups:', IDFWMarketGroups])
          debugLog(['-----------------------------'])
        }
        allPopularParlays.forEach(parlay => {
          const origin = getOrigin(parlay.SelectionData)
          const liveEvents = BettingOffer.computed.liveEvents()
          let hasLiveEvents = parlay && parlay.SelectionData && parlay.SelectionData.some(selection => liveEvents && liveEvents.filter(ev => ev.idfoevent === selection.market.idfoevent).length > 0)
          if (parlay) {
            parlay['isLiveParlay'] = hasLiveEvents
          }
          let selectionsCountValid = parlay && parlay.SelectionData && parlay.SelectionData.length &&
            ((config.app.autoconf.PLAYER_PERSONALISATION.minNumOfSelectionPerParlay === false || config.app.autoconf.PLAYER_PERSONALISATION.maxNumOfSelectionsPerParlay === false) ||
              (parlay.SelectionData.length >= config.app.autoconf.PLAYER_PERSONALISATION.minNumOfSelectionPerParlay && parlay.SelectionData.length <= config.app.autoconf.PLAYER_PERSONALISATION.maxNumOfSelectionsPerParlay))
          //
          debugLog(['PopularParlay', parlay.Name, parlay.IDFWMarketGroup])
          debugLog(['Legs:', parlay.SelectionData.length, '; selectionsCountValid:', selectionsCountValid, ':', (selectionsCountValid ? 'OK' : 'NOT-OK')])
          debugLog(['HasLiveEvents:', hasLiveEvents, '; (config liveEventsAvailableForPopularParlays:', config.app.autoconf.PLAYER_PERSONALISATION.liveEventsAvailableForPopularParlays, ')', ':', ((config.app.autoconf.PLAYER_PERSONALISATION.liveEventsAvailableForPopularParlays || (!config.app.autoconf.PLAYER_PERSONALISATION.liveEventsAvailableForPopularParlays && !hasLiveEvents)) ? 'OK' : 'NOT-OK')])
          debugLog(['Origin:', origin])
          //
          if (selectionsCountValid && (config.app.autoconf.PLAYER_PERSONALISATION.liveEventsAvailableForPopularParlays || (!config.app.autoconf.PLAYER_PERSONALISATION.liveEventsAvailableForPopularParlays && !hasLiveEvents))) {
            let isValidForParlay = isParlayValid(parlay) || isSGPValid(parlay) || isSGPPlusValid(parlay)

            debugLog(['Has valid calculation:', isValidForParlay, ':', (isValidForParlay ? 'OK' : 'NOT-OK')])
            if (isValidForParlay) {
              let priceCheck = config.app.autoconf.PLAYER_PERSONALISATION.acceptSelectionsWithNoPrice
              if (!priceCheck) {
                priceCheck = parlay && parlay.SelectionData.every(price => {
                  return price.selections[0].currentpriceup !== null && price.selections[0].currentpriceup !== undefined &&
                    price.selections[0].currentpricedown !== null && price.selections[0].currentpricedown !== undefined
                })
              }
              debugLog(['All legs have price:', priceCheck, '; (config acceptSelectionsWithNoPrice:', config.app.autoconf.PLAYER_PERSONALISATION.acceptSelectionsWithNoPrice, ')', ':', (priceCheck ? 'OK' : 'NOT-OK')])
              if (priceCheck) {
                if (!isParlayZone && popularParlays.length >= config.app.autoconf.PLAYER_PERSONALISATION.maxNumOfPopularParlays) {
                  let oldest = popularParlays.pop()
                  setTimeout(() => {
                    debugLog(['Not displayed', oldest.Name, oldest.IDFWMarketGroup, '(over maxNumOfPopularParlays:', config.app.autoconf.PLAYER_PERSONALISATION.maxNumOfPopularParlays, ')'])
                  }, 0)
                }
                popularParlays.push(parlay)
              }
            }
          }
          debugLog(['-----------------------------'])
        })
        debugLog(['Popular Parlays: Valid Parlays - ', popularParlays])
        store.commit('popularParlaysState/setPopularParlays', popularParlays)
      })
      .catch(error => {
        console.error('Popular Parlays fetch error:', error)
        store.commit('popularParlaysState/setPopularParlays', [])
      })
      .finally(() => {
        store.commit('popularParlaysState/setIsLoading', false)
        store.commit('popularParlaysState/setExpansionPanel', 0)
        store.commit('popularParlaysState/setLoadPopularParlaysComplete')
        store.commit('featureTabsState/setIsLoading', false)
      })
  }
}

function debugLog (dataArr) {
  if (!router.currentRoute.query.debug) {
    return
  }
  console.log(...dataArr)
}

function getOrigin (parlay) {
  const origin = parlay.find(sel => sel.selections[0].origin)
  return origin ? origin.selections[0].origin : ''
}

function betType (parlay) {
  if (parlay.BetCalculation.CalculationXP) return 'SGP+'
  else if (parlay.BetCalculation.ProviderCalculation) return 'SGP'
  else return 'Parlay'
}

function isParlay (parlay) {
  return betType(parlay) === 'Parlay'
}
function isParlayValid (parlay) {
  if (!isParlay(parlay)) return false

  let allowedBetTypes = parlay.BetCalculation.Calculation &&
    parlay.BetCalculation.Calculation.AllowedBetTypes &&
    parlay.BetCalculation.Calculation.AllowedBetTypes.length > 0 &&
    parlay.BetCalculation.Calculation.AllowedBetTypes.find(bt => bt.BetTypeInstruction === 'A')
  let parlayBetType = allowedBetTypes && allowedBetTypes.IDFOBetType
  let potentialReturn = parlay.BetCalculation.Calculation.PotentialReturns &&
    parlay.BetCalculation.Calculation.PotentialReturns.PerBetType &&
    parlay.BetCalculation.Calculation.PotentialReturns.PerBetType[parlayBetType] &&
    parlay.BetCalculation.Calculation.PotentialReturns.PerBetType[parlayBetType].PotentialReturn

  return allowedBetTypes && potentialReturn
}

function isSGP (parlay) {
  return betType(parlay) === 'SGP'
}
function isSGPValid (parlay) {
  if (!isSGP(parlay)) return false

  let providerCalc = parlay.BetCalculation.ProviderCalculation &&
    parlay.BetCalculation.ProviderCalculation.length > 0 &&
    parlay.BetCalculation.ProviderCalculation[0]

  return providerCalc && providerCalc.Bets[0].Status === 'OK' && providerCalc.Bets[0].Price
}

function isSGPPlus (parlay) {
  return betType(parlay) === 'SGP+'
}
function isSGPPlusValid (parlay) {
  if (!isSGPPlus(parlay)) return false

  let allowedBetTypes = parlay.BetCalculation.CalculationXP &&
    parlay.BetCalculation.CalculationXP.AllowedBetTypes &&
    parlay.BetCalculation.CalculationXP.AllowedBetTypes.length > 0 &&
    parlay.BetCalculation.CalculationXP.AllowedBetTypes.find(bt => bt.BetTypeInstruction === 'A')
  let parlayBetType = allowedBetTypes && allowedBetTypes.IDFOBetType
  let potentialReturn = parlay.BetCalculation.CalculationXP.PotentialReturns &&
    parlay.BetCalculation.CalculationXP.PotentialReturns.PerBetType &&
    parlay.BetCalculation.CalculationXP.PotentialReturns.PerBetType[parlayBetType] &&
    parlay.BetCalculation.CalculationXP.PotentialReturns.PerBetType[parlayBetType].PotentialReturn

  return allowedBetTypes && potentialReturn
}

function parlayPotentialReturn (calculation, isSGP) {
  // console.log('parlayPotentialReturn:', calculation, 'isSGP:', isSGP)
  if (isSGP) {
    let potentialReturn = calculation && calculation[0] && calculation[0].Bets && calculation[0].Bets[0] && calculation[0].Bets[0].Price
    return Number(potentialReturn)
  }
  let btA = calculation && calculation.AllowedBetTypes && calculation.AllowedBetTypes.find(abt => abt.BetTypeInstruction === 'A')
  // let iDFOBetType = (btA && btA.IDFOBetType) || 'A'
  let iDFOBetType = (btA && btA.IDFOBetType)
  let potentialReturn = iDFOBetType && calculation.PotentialReturns &&
    calculation.PotentialReturns.PerBetType &&
    calculation.PotentialReturns.PerBetType[iDFOBetType] &&
    calculation.PotentialReturns.PerBetType[iDFOBetType].PotentialReturn
  potentialReturn = potentialReturn || 0
  // console.log('parlayPotentialReturn:', calculation, 'iDFOBetType:', iDFOBetType, 'potentialReturn:', potentialReturn)
  return potentialReturn
}



// WEBPACK FOOTER //
// ./src/library/personalization/popularParlays.js